import gql from "graphql-tag";

const GET_PATIENT_BY_PHONE = gql`
  query getPatient($phone: String!) {
    patient(phone: $phone)
      @rest(
        type: "getPatient"
        path: "/lookup_patient/{args.phone}"
        endpoint: "v1"
      ) {
      status
    }
  }
`;

export { GET_PATIENT_BY_PHONE };
